import { DokuLinkSearchResponse, RechtVersionListEntry } from '../../../core/gb-api';
import { Observable } from 'rxjs';
import { DokulinkItemBuilder } from './dokulinkItemBuilder';
import { DokulinkItemSubtype } from './dokulinkItemBuilderFactory';
import DokulinkVerfuegbarEnum = RechtVersionListEntry.DokulinkVerfuegbarEnum;

export type DokuLinkTypeEnum = 'Geschaeft' | 'Grundstueck' | 'Recht' | 'Beleg' | 'AlteGrundbuchmeldung';

export type BelegAltReferenzObjektTyp =
  | 'NATUERLICHE_PERSON'
  | 'AUSLAENDISCHE_RECHTSFORM'
  | 'OEFFENTLICHE_KOERPERSCHAFT'
  | 'SCHWEIZERISCH_JURISTISCHE_PERSON'
  | 'ANMERKUNG'
  | 'VORMERKUNG'
  | 'DIENSTBARKEIT'
  | 'EGVTAuftrag'
  | 'GRUNDLAST'
  | 'GRUNDPFANDRECHT'
  | 'GRUNDSTUECK'
  | 'GRUNDBUCHMELDUNG'
  | 'GRUNDBUCHGESCHAEFT'
  | 'GEOMETERGESCHAEFT'
  | 'PFANDRECHT'
  | 'STANDARDRECHT'
  | 'RECHTSGRUND'
  | 'PERSONGB'
  | 'PERSONSTAMM'
  | 'PERSONSTAMMMASTER'
  | 'BAUPROJEKT'
  | 'GEBAEUDE'
  | 'WOHNUNG';

export class DokulinkItem {
  id: string;
  type: DokuLinkTypeEnum;
  tooltipParam: string;
  subtype: DokulinkItemSubtype;
  model: any;
  hasPermission: boolean;
  valid = false;

  getLink$: Observable<DokuLinkSearchResponse>;
  links?: DokuLinkSearchResponse;

  hasLink$: Observable<Boolean>;
  verfuegbar?: DokulinkVerfuegbarEnum;

  constructor(builder: DokulinkItemBuilder<any>) {
    this.id = builder.id;
    this.type = builder.type;
    this.tooltipParam = builder.tooltip;
    this.model = builder.model;
    this.subtype = builder.subtype;
    this.verfuegbar = builder.verfuegbar;
    this.getLink$ = builder.dokulinkResolver$;
    this.hasLink$ = builder.haslinkResolver$;
    this.hasPermission = builder.hasPermission;
    this.valid = builder.valid;
  }
}
